// Japanese translations
const ja = {
  cover: {
    title: "チェス王国",
    subtitle: "キングスコート",
    riseOfDukes: "公爵の台頭",
    enter: "入場",
    aboutUs: "私たちについて",
    tagline: "伝説が生まれる場所、すべての手が物語を紡ぐ",
    selectLanguage: "言語を選択"
  },
  auth: {
    login: "ログイン",
    register: "登録",
    email: "メールアドレス",
    password: "パスワード",
    confirmPassword: "パスワード確認",
    username: "ユーザー名",
    forgotPassword: "パスワードを忘れた？",
    noAccount: "アカウントがない？",
    hasAccount: "アカウントをお持ちの方",
    signUp: "登録",
    signIn: "ログイン",
    orContinueWith: "または続行",
    guest: "ゲストでプレイ",
    logout: "ログアウト"
  },
  lobby: {
    title: "ロビー",
    subtitleRise: "公爵の",
    subtitleDukes: "台頭",
    quickPlay: "クイックプレイ",
    createRoom: "ルーム作成",
    joinRoom: "参加",
    settings: "設定",
    skins: "スキン",
    friends: "フレンド",
    chat: "チャット",
    spectate: "観戦",
    roomCode: "ルームコード",
    enterRoomCode: "コードを入力...",
    join: "参加",
    create: "作成",
    private: "プライベート",
    public: "公開",
    players: "プレイヤー",
    waiting: "対戦相手を待機中...",
    ready: "準備完了",
    start: "開始",
    gameSetup: "ゲーム設定",
    chooseVariant: "バリアントとモードを選択",
    multiplayer: "マルチプレイヤー",
    onlineMatches: "オンライン対戦",
    profile: "プロフィール",
    messages: "メッセージ",
    assistant: "アシスタント",
    help: "ヘルプ",
    exit: "退出"
  },
  game: {
    white: "白",
    black: "黒",
    whiteToMove: "白の番",
    blackToMove: "黒の番",
    check: "チェック！",
    checkmate: "チェックメイト！",
    stalemate: "ステイルメイト！",
    draw: "引き分け",
    resign: "投了",
    resigns: "投了",
    forfeits: "棄権",
    offerDraw: "引き分けを提案",
    acceptDraw: "引き分けを承諾",
    declineDraw: "引き分けを拒否",
    newGame: "新しいゲーム",
    leave: "退出",
    rules: "ルール",
    moveHistory: "棋譜",
    noMovesYet: "まだ手がありません",
    movesWillAppear: "手はここに表示されます",
    yourTurn: "あなたの番",
    opponentTurn: "相手の番",
    gameOver: "ゲーム終了",
    youWin: "勝利！",
    youLose: "敗北",
    whiteWins: "白の勝利！",
    blackWins: "黒の勝利！",
    drawGame: "引き分け！",
    playAgain: "もう一度プレイ",
    backToLobby: "ロビーに戻る",
    classic: "クラシック",
    kingsCourt: "王の宮廷",
    fightToBeKing: "王座を争う",
    kingCaptured: "キング捕獲！",
    winner: "勝者",
    rematch: "再戦",
    decline: "拒否",
    waiting: "待機中...",
    acceptRematch: "再戦を承諾",
    wantsRematch: "が再戦を希望！",
    rematchAccepted: "再戦承諾！新しいゲームを開始...",
    rematchDeclined: "再戦拒否。ロビーに戻ります...",
    waitingForOpponent: "対戦相手を待機中...",
    startingNewGame: "新しいゲームを開始中...",
    continue: "続行"
  },
  settings: {
    title: "設定",
    boardCustomization: "ボードと駒のカスタマイズ",
    livePreview: "ライブプレビュー",
    previewDescription: "カスタマイズをプレビュー",
    boardTheme: "ボードの色",
    pieceTheme: "駒の色",
    customColors: "カスタムカラー",
    presetThemes: "プリセットテーマ",
    lightSquares: "明るいマス",
    darkSquares: "暗いマス",
    whitePieces: "白の駒",
    blackPieces: "黒の駒",
    coordinateColor: "座標の色",
    coordinateDescription: "数字(1-8)と文字(a-h)の色をカスタマイズ",
    chessPieceSkins: "駒スキン",
    chessPieceSkinsDescription: "標準の駒をプレミアム3Dスキンに変更",
    dukeSkins: "デュークスキン",
    dukeSkinsDescription: "デュークスキンを選択 - ボードの色が自動調整！",
    whiteSideDuke: "白側デューク",
    blackSideDuke: "黒側デューク",
    autoMatchBoard: "ボードの色を自動調整",
    saveAndClose: "保存して閉じる",
    reset: "リセット",
    close: "閉じる",
    premium: "プレミアム",
    default: "デフォルト",
    classic: "クラシック",
    viewMode: "表示モード",
    viewModeDescription: "ボードの表示方法を選択",
    topDown: "上から見る",
    topDownDescription: "従来の平面表示",
    perspective3D: "3D視点",
    perspective3DDescription: "動的な3D角度の2D駒",
    skinsApplyTo: "キング、クイーン、ルーク、ビショップ、ナイト、ポーンに適用",
    dukeHint: "左：即座に王 · 右：王座を争う"
  },
  store: {
    title: "スキンショップ",
    subtitle: "キングスコート",
    riseOfDukes: "公爵の台頭",
    chessPieces: "チェス駒",
    dukeSkins: "デュークスキン",
    allPiecesBundle: "全駒スキンバンドル",
    allDukeBundle: "全デュークスキンバンドル",
    bundleDiscount: "全プレミアムスキン30%オフ！",
    owned: "所有",
    equip: "装備",
    buy: "購入",
    processing: "処理中...",
    free: "無料",
    rare: "レア",
    epic: "エピック",
    legendary: "レジェンダリー",
    common: "コモン",
    securePayment: "一度の購入 • 永久使用 • 安全な支払い"
  },
  chat: {
    title: "チャット",
    lobbyChat: "ロビーチャット",
    gameChat: "ゲームチャット",
    typeMessage: "メッセージを入力...",
    send: "送信",
    spectatorChat: "観戦者チャット",
    playerChat: "プレイヤーチャット"
  },
  friends: {
    title: "フレンド",
    online: "オンライン",
    offline: "オフライン",
    addFriend: "フレンド追加",
    removeFriend: "削除",
    invite: "招待",
    pending: "保留中",
    accept: "承諾",
    decline: "拒否",
    friendRequests: "フレンド申請",
    noFriends: "フレンドがいません",
    searchPlayers: "プレイヤーを検索..."
  },
  notifications: {
    friendRequest: "がフレンド申請を送りました",
    gameInvite: "が対戦に招待しました",
    yourTurn: "あなたの番です！",
    opponentJoined: "対戦相手が参加しました",
    opponentLeft: "対戦相手が退出しました",
    drawOffered: "相手が引き分けを提案しました",
    connected: "サーバーに接続しました",
    disconnected: "サーバーから切断しました",
    reconnecting: "再接続中..."
  },
  errors: {
    invalidEmail: "無効なメールアドレス",
    invalidPassword: "パスワードは6文字以上必要です",
    passwordMismatch: "パスワードが一致しません",
    loginFailed: "ログイン失敗。認証情報を確認してください",
    registerFailed: "登録失敗。もう一度お試しください",
    connectionError: "接続エラー。もう一度お試しください",
    connectionErrorInternet: "接続エラー。インターネット接続を確認してください",
    gameNotFound: "ゲームが見つかりません",
    roomFull: "ルームが満員です",
    invalidMove: "無効な手",
    pleaseEnterName: "名前を入力してください",
    completeBothSecurityQuestions: "セキュリティ質問を両方入力するか、空白のままにしてください",
    selectDifferentQuestions: "異なる質問を選択してください",
    unexpectedError: "予期しないエラーが発生しました",
    failedToSendResetCode: "リセットコードの送信に失敗しました",
    invalidOrExpiredCode: "無効または期限切れのコード",
    failedToResetPassword: "パスワードのリセットに失敗しました",
    pleaseEnterRoomName: "ルーム名を入力してください",
    pleaseEnterRoomCode: "ルームコードを入力してください",
    roomCodeMustBe6Chars: "コードは6文字必要です",
    roomNotFound: "ルームが見つかりません。コードを確認してください",
    roomRequiresApproval: "このルームは承認が必要です。リストから申請してください",
    failedToCreateRoom: "ルームの作成に失敗しました",
    failedToJoinRoom: "ルームへの参加に失敗しました",
    failedToLeaveRoom: "ルームからの退出に失敗しました",
    failedToRemoveRoom: "ルームの削除に失敗しました",
    failedToLoadGames: "ゲームの読み込みに失敗しました",
    failedToRequestRejoin: "再参加リクエストに失敗しました",
    failedToJoinMatchmaking: "マッチメイキングへの参加に失敗しました",
    noOpponentFound: "対戦相手が見つかりません。後でもう一度お試しください",
    searchFailed: "検索に失敗しました",
    failedToSendRequest: "リクエストの送信に失敗しました",
    failedToAcceptRequest: "リクエストの承認に失敗しました",
    failedToRejectRequest: "リクエストの拒否に失敗しました",
    failedToCancelRequest: "リクエストのキャンセルに失敗しました",
    failedToRemoveFriend: "フレンドの削除に失敗しました"
  },
  success: {
    copiedToClipboard: "クリップボードにコピーしました！",
    rejoinRequestSent: "ホストにリクエストを送信しました！",
    roomRemovedFromList: "リストからルームを削除しました",
    leftRoomSuccessfully: "ルームから退出しました",
    requestRejected: "リクエストを拒否しました",
    requestCancelled: "リクエストをキャンセルしました",
    friendRemoved: "フレンドを削除しました",
    tournamentCreated: "トーナメントを作成しました！",
    tournamentJoined: "トーナメントに参加しました！",
    tournamentLeft: "トーナメントから退出しました",
    tournamentStarted: "トーナメントが開始されました！",
    tournamentCancelled: "トーナメントがキャンセルされました",
    tournamentsCleared: "すべてのトーナメントを削除しました",
    removedFromHistory: "履歴から削除しました"
  },
  tournament: {
    title: "トーナメント",
    createTournament: "トーナメント作成",
    joinTournament: "トーナメント参加",
    leaveTournament: "トーナメント退出",
    startTournament: "トーナメント開始",
    cancelTournament: "トーナメントキャンセル",
    clearAll: "すべて削除",
    myTournaments: "マイトーナメント",
    availableTournaments: "参加可能なトーナメント",
    tournamentHistory: "トーナメント履歴",
    bracket: "トーナメント表",
    participants: "参加者",
    status: "ステータス",
    waiting: "待機中",
    inProgress: "進行中",
    completed: "完了",
    cancelled: "キャンセル",
    format: "形式",
    singleElimination: "シングルエリミネーション",
    doubleElimination: "ダブルエリミネーション",
    swiss: "スイス式",
    round: "ラウンド",
    match: "マッチ",
    ready: "準備完了",
    notReady: "準備中",
    markReady: "準備完了にする",
    winner: "勝者",
    loser: "敗者",
    bye: "シード",
    pleaseLoginToCreate: "トーナメントを作成するにはログインしてください",
    pleaseLoginToJoin: "トーナメントに参加するにはログインしてください",
    failedToLoadTournaments: "トーナメントの読み込みに失敗しました",
    failedToCreateTournament: "トーナメントの作成に失敗しました",
    failedToJoinTournament: "トーナメントへの参加に失敗しました",
    failedToLeaveTournament: "トーナメントからの退出に失敗しました",
    failedToStartTournament: "トーナメントの開始に失敗しました",
    failedToCancelTournament: "トーナメントのキャンセルに失敗しました",
    failedToClearTournaments: "トーナメントの削除に失敗しました",
    failedToRemoveFromHistory: "履歴からの削除に失敗しました",
    failedToLoadTournament: "トーナメントの読み込みに失敗しました",
    failedToMarkReady: "準備完了の設定に失敗しました"
  },
  ranked: {
    title: "ランクマッチ",
    findMatch: "ランクマッチを探す",
    inQueue: "待機中...",
    leaveQueue: "待機をキャンセル",
    yourRank: "あなたのランク",
    elo: "ELO",
    tier: "ティア",
    wins: "勝利",
    losses: "敗北",
    draws: "引き分け",
    season: "シーズン",
    leaderboard: "リーダーボード",
    squire: "見習い",
    knight: "騎士",
    baron: "男爵",
    duke: "公爵",
    king: "王",
    pleaseLoginToPlay: "ランクマッチにはログインが必要です",
    failedToJoinQueue: "待機列への参加に失敗しました"
  },
  misc: {
    loading: "読み込み中...",
    cancel: "キャンセル",
    confirm: "確認",
    yes: "はい",
    no: "いいえ",
    ok: "OK",
    save: "保存",
    delete: "削除",
    edit: "編集",
    back: "戻る",
    next: "次へ",
    previous: "前へ",
    search: "検索",
    filter: "フィルター",
    sort: "並べ替え",
    all: "すべて",
    none: "なし",
    select: "選択",
    selected: "選択済み"
  },
  
  // About Us Page
  aboutUs: {
    back: "← 戻る",
    title: "Chess Kingdom: キングスコートへようこそ",
    subtitle: "キングスコート",
    riseOfDukes: "公爵の台頭",
    description: "クラシックな戦略が神話的スケールと出会う王国へ。キングスコートは単なるゲームモード以上のもの—それは戦術家、夢想家、チャンピオンのための試練の場です。新しい挑戦を求める名人であれ、征服のスリルに惹かれる初心者であれ、ここがあなたの競技場です。⚔️",
    keyFeatures: "主な特徴",
    feature1Title: "ダイナミックなバリエーション",
    feature1Desc: "進化するルールセットとボードレイアウトを探索し、適応力と先見の明を試してください。",
    feature2Title: "宮廷の昇進",
    feature2Desc: "称号を獲得し、紋章を解放し、熟練とスタイルを報いる豊富なランキングシステムを昇進してください。",
    feature3Title: "スキルベースのプレイ",
    feature3Desc: "透明なフィードバック、テレメトリ調整されたバランス、公平なマッチメイキングにより、すべての勝利が正当に得られます。",
    feature4Title: "ライブチャットとストーリー",
    feature4Desc: "ライバルや同盟者とつながり、手続き型のロアを発見し、王国の神話を形作ってください。",
    feature5Title: "プロのために構築",
    feature5Desc: "精密な調整、リプレイ分析、トーナメント対応のインフラストラクチャにより、キングスコートは競技プレイの本格的なプラットフォームとなっています。",
    closingStatement: "栄光、成長、または壮大な戦略を求めているなら、キングスコートは知恵で統治し、名誉をもって戦い、王国にあなたの足跡を残すようあなたを招待します。",
    developmentNotice: "注意：ゲームはまだ開発中であり、あなたの忍耐とサポートにより、ゲームは第二の我が家となるでしょう。楽しんで、友達や同盟を作ってください。完成したら、あなたの戦略的な勝利方法が試されます...あなたの王国へようこそ...",
    contactTitle: "詳細情報や提案のお問い合わせ：",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "スキンショップ",
    themedSets: "テーマセット",
    pieceSkins: "駒のスキン",
    dukeSkins: "公爵スキン",
    unlockSet: "セットを解放",
    owned: "所有済み",
    price: "価格",
    checkout: "チェックアウト",
    addToCart: "カートに追加",
    cart: "カート",
    total: "合計",
    continueShopping: "買い物を続ける",
    proceedToCheckout: "レジに進む",
    emptyCart: "カートは空です",
    itemAdded: "商品をカートに追加しました",
    purchaseSuccess: "購入成功！",
    purchaseFailed: "購入に失敗しました。もう一度お試しください。"
  },
  
  // Rules
  rules: {
    title: "ゲームルール",
    classic: "クラシックチェス",
    classicDesc: "標準的なチェスのルール - 相手のキングをチェックメイトして勝利。",
    instantKing: "インスタントキング",
    instantKingDesc: "敵のキングを直接捕獲して勝利 - チェックメイト不要！",
    fightToBeKing: "王位をかけた戦い",
    fightToBeKingDesc: "昇格したポーンが新しいキングになります！守れなければ負けです。",
    timerRules: "タイマールール",
    timerDesc: "各プレイヤーは1手ごとに制限時間があります。時間切れになると、ターンがスキップされます。"
  },
  
  // Assistant
  assistant: {
    title: "Chess Kingdomアシスタント",
    searchPlaceholder: "ヘルプトピックを検索...",
    randomTip: "ランダムなヒントを表示",
    noResults: "該当するヘルプトピックがありません",
    noResultsHint: "別のキーワードを試すか、上のカテゴリーを参照してください",
    categories: {
      gettingStarted: "はじめに",
      dukeMechanics: "デュークの仕組み",
      multiplayer: "マルチプレイヤー",
      customization: "カスタマイズ",
      boardFeatures: "盤面機能",
      skinStore: "スキンストア",
      trialPayments: "トライアル＆支払い",
      strategyTips: "戦略ヒント",
      troubleshooting: "トラブルシューティング"
    },
    gettingStarted: {
      q1: "プレイを開始するには？",
      a1: "「ソロプレイ」をクリックしてAIと対戦、または「マルチプレイヤー」で他のプレイヤーと対戦できます。ゲストとしてプレイするか、48時間の無料トライアルに登録できます。",
      q2: "ゲームバリアントとは？",
      a2: "Chess Kingdomには7つのバリアントがあります：スタンダードチェス、インスタントキング、王位をかけた戦い、プレイヤーズチョイス、ワイルドポーン、Chess Kingdom（2デューク）、ハンディキャップモード。",
      q3: "盤面をカスタマイズするには？",
      a3: "設定ボタンをクリックしてカスタマイズオプションにアクセスできます。盤面の色、駒スキン、デュークスキン、テーマ、座標の色、表示モード、盤面サイズを変更できます。",
      q4: "盤面の表示を反転するには？",
      a4: "ゲームヘッダーの反転ボタンをクリックして、黒の視点から盤面を見ることができます。",
      q5: "盤面サイズを変更するには？",
      a5: "設定 → 盤面サイズに移動します。スライダーを使用するか、「コンパクト」(85%)、「デフォルト」(100%)、「大」(115%)をクリックします。"
    },
    dukeMechanics: {
      q1: "デュークとは何ですか？",
      a1: "デュークはビショップの代わりとなる特別な駒です。捕獲しない動きでは斜めに1マス移動しますが、8方向すべて（隣接マスのみ）で捕獲できます。",
      q2: "キングが捕獲されるとどうなりますか？",
      a2: "あなたのデュークが新しいキングに変身します！変身のルールはモードによって異なります：インスタントキングまたは王位をかけた戦い。",
      q3: "王位をかけた戦いはどのように機能しますか？",
      a3: "キングが捕獲された後、デュークは開始ライン（白は1列目、黒は8列目）に戻ってキングに変身する必要があります。",
      q4: "デュークは昇格できますか？",
      a4: "ワイルドポーンバリアントでのみ可能です！ポーンが最終列に到達したとき、クイーン、ルーク、ビショップ、ナイト、またはデュークに昇格できます。",
      q5: "インスタントキングと王位をかけた戦いのスキンの違いは？",
      a5: "デュークスキンには2つのバージョンがあります：「インスタントキング」バージョンは通常プレイ中に表示され、「王位をかけた戦い」はデュークがベースラインに到達するために戦っているときに表示されます。"
    },
    multiplayer: {
      q1: "クイックマッチはどのように機能しますか？",
      a1: "クイックマッチは他のプレイヤーと即座にマッチングします！好みのゲームモードを選択し、「マッチを検索」をクリックすると、同じモードを選択した人とマッチングされます。",
      q2: "プライベートルームを作成・管理するには？",
      a2: "「ルーム作成」タブに移動し、ルーム名を入力、バリアントを選択、観戦設定を行い、6文字のコードを友達と共有します。",
      q3: "友達のルームに参加するには？",
      a3: "「ルーム参加」タブに移動し、友達が共有した6文字のコードを入力、「参加」をクリックします。",
      q4: "観戦設定とは？",
      a4: "プライベート：観戦者なし。リクエスト参加：観戦者は承認をリクエストする必要があります。オープン：誰でも自由に観戦できます。",
      q5: "観戦者としてゲームを見るには？",
      a5: "「観戦」タブに移動して、すべてのパブリックゲームを見ることができます。ゲームタイプでフィルタリングして特定のバリアントを見つけられます。",
      q6: "ゲーム中にチャットできますか？",
      a6: "はい！マルチプレイヤーゲーム中、ゲーム内チャットを使用できます。プレイヤーが異なる言語を話す場合、メッセージは自動的に翻訳されます！",
      q7: "テーマは対戦相手と同期されますか？",
      a7: "はい！ホスト（ルーム作成者）の場合、盤面テーマ、駒スキン、デュークスキンはすべてのプレイヤーと自動的に同期されます。"
    },
    customization: {
      q1: "どの駒スキンが利用可能ですか？",
      a1: "20以上のセットがあります：ゴールデン3D、オブシディアン3D、ヴィンテージ、カワイイ、フェイブル、ゴシック、コロッサル、アメジストパープル、サファイアブルー、ストーン＆サンドキングダムなど！",
      q2: "どのデュークスキンが利用可能ですか？",
      a2: "50以上のスキンがカテゴリー別にあります：メタリック（ゴールド、シルバー）、カラー（パープル、ブルー、エメラルド）、ホワイト（スパルタン、イーグル）、ブラック（スチール、クラウン）、ジェムストーン、キングダム、3Dプレミアムなど！",
      q3: "駒スキンを変更するには？",
      a3: "設定 → 駒スキン。白と黒の側に別々のスキンを設定できます！「両サイドプレビュー」を使用して、一緒にどのように見えるか確認できます。",
      q4: "デュークスキンを変更するには？",
      a4: "設定 → デュークスキン。白、黒、またはニュートラルでカテゴリー分けされたスキンを選択します。各デュークにはインスタントキングと王位をかけた戦いのバリアントがあります。",
      q5: "テーマパックとは？",
      a5: "テーマパックは駒スキン、デュークスキン、盤面テーマをまとめたものです！利用可能なパック：ロイヤルゴールド、ダークナイト、ヴィンテージクラシック、キングダムバトルパック！",
      q6: "ランダムテーマを取得するには？",
      a6: "「ランダムテーマパック」をクリックして完全にランダムなテーマを適用、または「ランダムキングダムバトル」でランダムな派閥対戦を適用します。",
      q7: "座標の色をカスタマイズできますか？",
      a7: "はい！設定 → 座標の色。列番号(1-8)と行文字(a-h)の任意の色を選択できます。"
    },
    boardFeatures: {
      q1: "表示モードとは？",
      a1: "2つのモード：3Dパースペクティブ（奥行きと影あり）とトップダウン（フラット、伝統的）。設定 → 表示モードで切り替えます。",
      q2: "盤面サイズ調整はどのように機能しますか？",
      a2: "設定 → 盤面サイズで80%（コンパクト）から120%（大）までスケーリングできます。デフォルトは100%です。",
      q3: "どの盤面テーマが利用可能ですか？",
      a3: "複数のカラーテーマ：クラシックウッド、ロイヤルゴールド、ダークナイト、オーシャンブルー、フォレストグリーン、ストーングレーなど。",
      q4: "座標はどのように機能しますか？",
      a4: "座標は盤面の端に列番号(1-8)と行文字(a-h)を表示します。盤面反転ボタンを使用すると正しく反転します！",
      q5: "盤面はモバイルで動作しますか？",
      a5: "はい！盤面は完全にレスポンシブです。横向きモードでは、盤面は自動的に画面の高さに合わせてサイズ調整されます。"
    },
    skinStore: {
      q1: "スキンストアにアクセスするには？",
      a1: "ロビーからストアボタンをクリックするか、設定 →「ストアを訪問」ボタンからアクセスします。ストアには3つのタブがあります：テーマセット、駒スキン、デュークスキン。",
      q2: "テーマセットとは？",
      a2: "割引価格の完全なテーマパッケージです！マッチする駒スキン、デュークスキン、盤面テーマが含まれています。",
      q3: "バンドル割引はありますか？",
      a3: "はい！「全駒スキンバンドル」と「全デュークスキンバンドル」ですべてのスキンが40%オフで手に入ります。",
      q4: "スキンのレアリティはどのように機能しますか？",
      a4: "コモン（グレー）：無料または基本。レア（ブルー）：199-249円。エピック（パープル）：249-399円。レジェンダリー（ゴールド）：349-499円。",
      q5: "購入前にプレビューできますか？",
      a5: "はい！任意のスキンカードにマウスを合わせるとプレビューが表示されます。駒スキンはキング、クイーン、ナイトを表示します。",
      q6: "購入したスキンを装備するには？",
      a6: "ストアで、所有しているスキンは価格の代わりに「装備」ボタンが表示されます。装備をクリックして即座に適用します。"
    },
    trialPayments: {
      q1: "48時間無料トライアルとは？",
      a1: "新規ユーザーはすべてのバリアントに48時間の無料アクセスを取得できます。トライアル終了後、スタンダードチェスとインスタントキングは無料のままです。",
      q2: "バリアントの価格は？",
      a2: "王位をかけた戦い＆ハンディキャップモード：299円、プレイヤーズチョイス：399円、ワイルドポーン＆2デューク：499円。または全バリアントバンドルが899円！",
      q3: "スキンの価格は？",
      a3: "個別スキン：レアリティにより199-499円。バンドル：約40%オフ。テーマセット：899-1299円。",
      q4: "ゲストとしてプレイできますか？",
      a4: "はい！ゲストモードでは登録なしで即座にプレイできます。ただし、ゲーム履歴は保存されません。",
      q5: "支払いはどのように機能しますか？",
      a5: "すべての支払いはStripeを通じて安全に処理されます。一度の購入でコンテンツが永久にアンロックされます。サブスクリプションは必要ありません。"
    },
    strategyTips: {
      q1: "デュークのオープニング戦略？",
      a1: "早い段階でデュークを中央の対角線を制御する位置に配置します。8方向への捕獲能力により、複数の駒を脅かすのに優れています。",
      q2: "インスタントキングと王位をかけた戦いの選択時期は？",
      a2: "デュークが良い位置にある場合はインスタントキングを選択。デュークがすでにベースライン近くにある場合は王位をかけた戦いを選択。",
      q3: "2デュークバリアントの戦略？",
      a3: "両方のデュークを注意深く守りましょう - これらはあなたの「追加ライフ」です！キングが捕獲されたとき、変身のためにより安全なデュークを選択します。",
      q4: "ワイルドポーンの終盤？",
      a4: "「キング保険」としてポーンをデュークに昇格させることを検討してください - 後でキングが捕獲された場合、昇格したデュークが新しいキングになれます！",
      q5: "盤面反転を戦略的に使用する？",
      a5: "盤面を反転して対戦相手の視点からポジションを見ましょう！見逃す可能性のある脅威を特定するのに役立ちます。"
    },
    troubleshooting: {
      q1: "ゲームの読み込みが遅い",
      a1: "トラブルシューターボタンを試して診断を実行してください。インターネット接続を確認してください。ページの更新を試してください（Ctrl+F5）。",
      q2: "マルチプレイヤーが接続しない",
      a2: "トラブルシューターを使用してWebSocket接続状態を確認してください。ログインしていることを確認してください。ファイアウォール/VPNの問題を確認してください。",
      q3: "設定が保存されない",
      a3: "設定はlocalStorageを使用します。ブラウザがそれを許可しているか確認してください。トラブルシューターの「設定リセット」オプションを試してください。",
      q4: "手順履歴はどこにありますか？",
      a4: "手順履歴サイドバーはアクティブなゲーム中に右側に表示されます。ブラウザ幅 > 768pxが必要です。",
      q5: "盤面サイズスライダーが機能しない？",
      a5: "試してください：1）ページを更新。2）ブラウザキャッシュをクリア。3）ゲーム中かどうか確認。4）別の表示モードを試す。",
      q6: "駒が小さすぎる/大きすぎる？",
      a6: "異なる駒スキンには異なる最適サイズがあります。設定 → 盤面サイズに移動して調整してください。",
      q7: "パスワードを忘れた？",
      a7: "アカウントページ →「パスワードを忘れた？」→ セキュリティの質問に答える → パスワードがメールに送信されます。",
      q8: "サポートに連絡するには？",
      a8: "技術的な問題にはトラブルシューターを使用してください。請求/アカウントの問題については、アカウントページからメールを送信してください。"
    },
    tips: {
      tip1: "デュークは8方向に捕獲できますが、捕獲しないときは斜めにのみ移動します！",
      tip2: "王位をかけた戦いモードでは、デュークは変身するためにベースラインに到達する必要があります。",
      tip3: "デュークを複数のマスを制御する位置に配置しましょう - そのユニークな動きは強力です！",
      tip4: "2デュークバリアントでは、両方のデュークを守ることでより多くの逆転オプションが得られます。",
      tip5: "ワイルドポーンでは、デュークに昇格することで捕獲時の「キング保険」が得られます。",
      tip6: "クイックマッチ：対戦相手と同じゲームモードを選択すると即座にマッチングされます！",
      tip7: "作成したルームは「マイルーム」に、参加したルームは「参加ルーム」に表示されます。",
      tip8: "ルームを「オープン」に設定すると、誰でもあなたのエピックゲームを観戦できます！",
      tip9: "リクエストモード：プレイヤーは観戦者を承認する必要があります - プライベートレッスンに最適。",
      tip10: "最大5つのルームを作成できます。もっと作成するにはキャンセルまたは完了してください。",
      tip11: "設定をクリックして、いつでも盤面と駒の色を変更できます。",
      tip12: "すべての手は画面右側のサイドバーに記録されます。",
      tip13: "異なる言語を話すプレイヤーのためにメッセージは自動翻訳されます！",
      tip14: "各プライベートルームには友達と共有するための固有の6文字コードが付与されます。",
      tip15: "テーマパック：ワンクリックでマッチする駒、デューク、盤面テーマを入手！",
      tip16: "ストーン＆サンドvsウッドリンウォリアーズでエピックな派閥戦争を試してみてください！",
      tip17: "ゲームにランダムなテーマを選ばせましょう - 新しいお気に入りを発見！",
      tip18: "アメジストパープルとサファイアブルーであなたの駒が輝きます！",
      tip19: "反転ボタンをクリックして黒の視点から見ましょう - 分析に最適！",
      tip20: "モバイルでより大きな盤面表示のためにデバイスを回転させてください！",
      tip21: "設定のスライダーを使用して盤面を80%から120%にスケーリングできます！",
      tip22: "コロッサルセットはエピックな大理石とブロンズの彫刻駒を特徴としています！",
      tip23: "4つのかわいいカワイイ絵文字駒セット - ブラウン、ホワイト、ブラック、ベージュ！",
      tip24: "ゴシックホワイトとブラックセットは複雑なダークファンタジーデザインを特徴としています！",
      tip25: "フェイブル中世：十字軍騎士vs闇の戦士 - エピックバトル駒！"
    }
  },

  // Account Manager
  account: {
    title: "アカウント管理",
    accountInfo: "アカウント情報",
    usernameEmail: "ユーザー名/メール",
    displayName: "表示名",
    accountType: "アカウントタイプ",
    userId: "ユーザーID",
    guest: "ゲスト",
    registered: "登録済み",
    notAvailable: "N/A",
    notificationSettings: "通知設定",
    notificationSound: "通知音",
    notificationSoundDesc: "通知を受信したときに音を再生",
    security: "セキュリティ",
    passwordManagement: "パスワード管理",
    passwordNote: "セキュリティ上の理由から、パスワードは表示されません。パスワードをリセットする必要がある場合は、「パスワードを忘れた」機能を使用してください。",
    forgotPassword: "パスワードを忘れた？",
    passwordRecovery: "パスワード回復",
    passwordRecoveryHelp: "セキュリティの質問に答えてパスワードをメールで受け取る",
    securityQuestion1: "セキュリティの質問1",
    securityQuestion2: "セキュリティの質問2",
    selectQuestion: "質問を選択...",
    yourAnswer: "あなたの答え",
    sendPasswordEmail: "パスワードをメールで送信",
    securityQuestions: {
      q1: "最初のペットの名前は？",
      q2: "生まれた都市は？",
      q3: "母親の旧姓は？",
      q4: "小学校の名前は？",
      q5: "お気に入りの本は？",
      q6: "子供の頃のニックネームは？",
      q7: "お気に入りの先生の名前は？",
      q8: "育った通りの名前は？"
    },
    dangerZone: "危険ゾーン",
    deleteAccount: "アカウント削除",
    deleteAccountDesc: "アカウントとすべての関連データを完全に削除します。",
    deleteWarning: "これにより以下が完全に削除されます：",
    deleteWarningItems: {
      account: "アカウントとプロフィール",
      gameHistory: "すべてのゲーム履歴",
      friends: "フレンド接続",
      purchases: "購入したバリアント",
      settings: "設定と環境設定"
    },
    typeDelete: "確認のためDELETEと入力：",
    typeDeletePlaceholder: "ここにDELETEと入力",
    deleteForever: "アカウントを永久に削除",
    deleteConfirmMsg: "この操作は取り消せません。",
    deleteSuccess: "アカウントが正常に削除されました。ログアウトされます。",
    deleteFailed: "アカウントの削除に失敗しました",
    passwordResetSuccess: "パスワードリセット成功！パスワードがメールアドレスに送信されました。受信トレイ（および迷惑メールフォルダ）を確認してください。",
    securityAnswersIncorrect: "セキュリティの回答が正しくありません。もう一度お試しください。",
    passwordResetFailed: "パスワードリセットに失敗しました。もう一度お試しください。",
    answerBothQuestions: "両方のセキュリティの質問に答えてください"
  }
};

export default ja;
